import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './config/firebase';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);

// Handle iframe messaging
window.addEventListener('message', (event) => {
  // You can add specific origin checks here if needed
  if (event.data === 'getHeight') {
    const height = document.documentElement.scrollHeight;
    event.source?.postMessage({ type: 'height', height }, '*');
  }
});

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);